import PropTypes from 'prop-types'
import { createPortal } from 'react-dom'
import { Alert } from '@artprov/design-system'

/**
 * Toast flotante de la pantalla de selección de cuenta. Se monta en un portal
 * para quedar por encima del header y del menú.
 */
export default function ToastSeleccionCuenta({ toast, onClose }) {
  if (!toast) return null

  return createPortal(
    <div className="fixed top-4 right-4 w-[400px]" style={{ zIndex: 99999 }}>
      <Alert
        variant={toast.variant}
        iconStyle="default"
        title=""
        description={toast.message}
        descriptionStyle="whitespace-normal break-normal"
        interactive={true}
        buttonText=""
        onClose={onClose}
        containerStyle="!max-w-none w-full"
      />
    </div>,
    document.body
  )
}

ToastSeleccionCuenta.propTypes = {
  toast: PropTypes.shape({
    variant: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
  }),
  onClose: PropTypes.func.isRequired,
}
